import PropTypes from 'prop-types';
import { Menu } from '@szhsin/react-menu';
import _MenuItem from './_MenuItem';
import _SubMenuItem from './_SubMenuItem';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';

function ODropDownMenu2({ children, align, options, position }) {
  return (
    <Menu
      align={align}
      menuButton={children}
      transition
      position={position}
      portal={{ target: document.querySelector('.MuiDialog-container') }}
    >
      {options.map((item) =>
        item.subMenuOptions?.length > 0 ? (
          <_SubMenuItem key={item.title} option={item} />
        ) : (
          <_MenuItem key={item.title} option={item} />
        ),
      )}
    </Menu>
  );
}

export default ODropDownMenu2;

ODropDownMenu2.propTypes = {
  children: PropTypes.element.isRequired,
  align: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string, // opciono
      icon: PropTypes.string, // opciono nece se renderovati ako se ne posalje
      color: PropTypes.string, // opciono postoji defaultna boja
      disabled: PropTypes.bool, // opciono false po defaultu
      onClick: PropTypes.func.isRequired,
    }),
  ).isRequired,
};
